import { connect } from "react-redux";
import NavDrawer from "../NavDrawer";

import { getSavedCount } from "../../state/articles/save";
import { showModal, modals } from "../../state/modal";

const withRedux = connect(
  state => ({
    savedArticleCount: getSavedCount(state)
  }),
  dispatch => ({
    onDownloadClick() {
      const modal = {
        modalType: modals.DOWNLOAD_REPORT,
        modalProps: {}
      };
      dispatch(showModal(modal));
    }
  })
);

export default withRedux(NavDrawer);



// WEBPACK FOOTER //
// ./src/components/NavDrawer/container.js